<template lang="pug">
.question-answer-details-modal
  b-modal(v-model="_value" size="xl" @ok="ok" :title="title" no-close-on-backdrop no-close-on-esc)
    .question-answer-details-modal-body
      QuestionAnswerDetailsTable(
        v-model="_items"
        :fields="fields"
      )

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import QuestionAnswerDetailsTable, { QuestionAnswerDetailsTableField, QuestionAnswerDetailsTableItem } from "@/pc/containers/questionnaires/QuestionAnswerDetailsTable.vue";

/**
 * ### アンケートの回答結果詳細モーダル
 */
@Component({
  components: {
    QuestionAnswerDetailsTable
  }
})
export default class QuestionAnswerDetailsModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルタイトル */
  @Prop()
  title!: string;
  /** テーブル列情報 */
  @Prop({ required: true })
  fields!: Array<QuestionAnswerDetailsTableField>;
  /** テーブル行情報 */
  @Prop({ required: true })
  items!: Array<QuestionAnswerDetailsTableItem>;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _items(): Array<QuestionAnswerDetailsTableItem> {
    return this.items.filter((item) => {
      return item.answer ? true : false;
    });
  }

  set _items(newValue: Array<QuestionAnswerDetailsTableItem>) {
    this.$emit("update:items", newValue);
    return;
  }

  get _fields(): Array<QuestionAnswerDetailsTableField> {
    return this.fields;
  }

  set _fields(newValue: Array<QuestionAnswerDetailsTableField>) {
    this.$emit("update:fields", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>
